import moment from 'moment';

export function constructMomentFromDate(startDate) {
    if (startDate === undefined) {
        throw 'The start date should be specified.';
    }

    return moment(startDate);
}
